export default "__VITE_ASSET__Ciuqi6kT__"